import gql from "graphql-tag";

export default gql`query NewsStats {
    newsStats {
        id    
        body
        timestamp
        user {
            id
            name
        } 
    }
  }`